export default "__VITE_ASSET__Ds_szT$1__"